"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetFreeKeysButton = void 0;
const modal_context_1 = require("root/src/client/v2/common/contexts/modal-context");
const GetFreeKeysModal_1 = require("root/src/client/v2/creatorOnboarding/features/GetFreeKeysModal");
const useApplicationState_1 = require("root/src/client/v2/userData/hooks/useApplicationState");
const useGetStartedButton_1 = require("root/src/client/v2/creatorOnboarding/features/CreatorOnboardingButtons/hooks/useGetStartedButton");
function useGetFreeKeysButton() {
    const modal = (0, modal_context_1.useModal)();
    const { displayGetStartedButton } = (0, useGetStartedButton_1.useGetStartedButton)();
    const showGetFreeKeysModal = () => modal.show(<GetFreeKeysModal_1.GetFreeKeysModal />);
    const { applicationState } = (0, useApplicationState_1.useApplicationState)();
    const displayGetFreeKeysButton = !displayGetStartedButton && (applicationState === null || applicationState === void 0 ? void 0 : applicationState.isDisplayGetFreeKeysMessage);
    return {
        showGetFreeKeysModal,
        displayGetFreeKeysButton,
    };
}
exports.useGetFreeKeysButton = useGetFreeKeysButton;
